export default "__VITE_ASSET__Dxlu9B6$__"